import { useEffect, useRef } from "react";
import DatePickerHeader from "./DatePickerHeader";
import DatePickerYearGrid, { DatePickerMonthGrid } from "./Datepickergrids";
import DatePickerDays from "./DatePickerDays";

const WEEKDAYS = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"];

const DatePickerPopover = ({
  open,
  viewMode, // "days" | "months" | "years"
  displayDate, // { month, year }
  selectedDate,
  onPrev,
  onNext,
  onSelectDay,
  onSelectMonth,
  onSelectYear,
  onToggleView,
  onClear,
  onToday,
  onClose,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        ref.current &&
        !ref.current.closest(".dp-trigger-wrapper")?.contains(e.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, onClose]);

  return (
    <div ref={ref} className={`dp-popover ${open ? "dp-popover--open" : ""}`}>
      <DatePickerHeader
        month={displayDate.month}
        year={displayDate.year}
        viewMode={viewMode}
        onPrev={onPrev}
        onNext={onNext}
        onToggleView={onToggleView}
      />

      {viewMode === "years" && (
        <DatePickerYearGrid
          currentYear={displayDate.year}
          onSelectYear={onSelectYear}
        />
      )}

      {viewMode === "months" && (
        <DatePickerMonthGrid
          currentMonth={displayDate.month}
          onSelectMonth={onSelectMonth}
        />
      )}

      {viewMode === "days" && (
        <>
          <div className="dp-weekdays">
            {WEEKDAYS.map((d) => (
              <span key={d} className="dp-weekday">
                {d}
              </span>
            ))}
          </div>
          <DatePickerDays
            month={displayDate.month}
            year={displayDate.year}
            selectedDate={selectedDate}
            onSelectDay={onSelectDay}
          />
          <div className="dp-footer">
            <button className="dp-footer-clear" type="button" onClick={onClear}>
              Limpiar
            </button>
            <button className="dp-footer-today" type="button" onClick={onToday}>
              Hoy
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DatePickerPopover;
